export default __webpack_public_path__ + "static/media/03.f5db01d2.jpg";